require('./bootstrap');
require('./dialog_movable');
import 'vuetify/dist/vuetify.css';
import Vue from 'vue'
import Vuetify from 'vuetify'
import Router from './router'
import store from './store'
import App from './template/App';
import MasterApp from './template/MasterApp';
import Login from './auth/Login';
import VueDragscroll from 'vue-dragscroll';
import io from 'socket.io-client';
import VueParticles from 'vue-particles'
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";


Vue.config.productionTip = false;

const tokenExpiration = localStorage.getItem('tokenExpiration');
const isExpired = !tokenExpiration || Date.now() > tokenExpiration;

if (isExpired) {
  store.commit('clearToken');
}


Vue.use(Toast);
Vue.use(VueParticles)


// // const socket = io("https://websocketlinux2023.ihs-w.com",{ // NEW ICONN LINK
// const socket = io("https://iconntestlinux2023.ihs-w.com",{ // NEW ICONN LINK
// // const socket = io("https://iconntest.hrd-s.com",{ //  OLD ICONN LINK - UPDATED 20260603
//     transports: ["websocket"]
// });


// const socket = io("https://websocketlinux2023.ihs-w.com",{ // NEW ICONN LINK
const socketConnection = io("https://iconntestlinux2023.ihs-w.com",{ // NEW ICONN LINK
// const socket = io("https://iconntest.hrd-s.com",{ //  OLD ICONN LINK - UPDATED 20260603
    transports: ["polling", "websocket"]
});

// Vue.prototype.$socket = socket;
import VueSocketIO from 'vue-socket.io'

Vue.use(new VueSocketIO({
    // debug: false,
    // connection: io('https://websocketlinux2023.ihs-w.com', { // NEW ICONN LINK
    // connection: io('https://iconntestlinux2023.ihs-w.com', { // NEW ICONN LINK
    // // connection: io('https://iconntest.hrd-s.com', { // OLD ICONN LINK - UPDATED 20260603
    //     transports: ["websocket"]
    // }), //options object is Optional
    connection: socketConnection,
    vuex: {
        store,
        actionPrefix: "SOCKET_",
        mutationPrefix: "SOCKET_"
        }
    })
);


Vue.use(VueDragscroll)
Vue.use(Vuetify)
new Vue({
    el: '#app',
    store,
    router:Router,
    vuetify: new Vuetify(),
    components : {
        App,
        Login,
        MasterApp
    }
    // render: h=>h(App)
});
